(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[177],{

/***/ 3238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ BreadcrumbLink; },
/* harmony export */   "aG": function() { return /* binding */ Breadcrumb; },
/* harmony export */   "gN": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* unused harmony exports BreadcrumbSeparator, useBreadcrumbStyles */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(187);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5235);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4520);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2446);
// ../../react-shim.js


// src/breadcrumb.tsx





// src/breadcrumb-context.ts

var [BreadcrumbStylesProvider, useBreadcrumbStyles] = (0,_chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .kr)({
  name: `BreadcrumbStylesContext`,
  errorMessage: `useBreadcrumbStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Breadcrumb />" `
});

// src/breadcrumb.tsx
var Breadcrumb = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function Breadcrumb2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useMultiStyleConfig */ .jC)("Breadcrumb", props);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  const {
    children,
    spacing = "0.5rem",
    separator = "/",
    className,
    ...rest
  } = ownProps;
  const validChildren = (0,_chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_1__/* .getValidChildren */ .WR)(children);
  const count = validChildren.length;
  const clones = validChildren.map((child, index) => (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
    separator,
    spacing,
    isLastChild: count === index + 1
  }));
  const _className = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-breadcrumb", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.nav */ .m$.nav, {
    ref,
    "aria-label": "breadcrumb",
    className: _className,
    __css: styles.container,
    ...rest
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.ol */ .m$.ol, {
    className: "chakra-breadcrumb__list"
  }, clones)));
});
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__/* .__DEV__ */ .Ts) {
  Breadcrumb.displayName = "Breadcrumb";
}

// src/breadcrumb-item.tsx




// src/breadcrumb-separator.tsx


var BreadcrumbSeparator = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbSeparator2(props, ref) {
  const { spacing, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const separatorStyles = {
    mx: spacing,
    ...styles.separator
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
    ref,
    role: "presentation",
    ...rest,
    __css: separatorStyles
  });
});
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__/* .__DEV__ */ .Ts) {
  BreadcrumbSeparator.displayName = "BreadcrumbSeparator";
}

// src/breadcrumb-link.tsx


var BreadcrumbLink = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbLink2(props, ref) {
  const { isCurrentPage, as, className, href, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const sharedProps = {
    ref,
    as,
    className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-breadcrumb__link", className),
    ...rest
  };
  if (isCurrentPage) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
      "aria-current": "page",
      __css: styles.link,
      ...sharedProps
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.a */ .m$.a, {
    __css: styles.link,
    href,
    ...sharedProps
  });
});
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__/* .__DEV__ */ .Ts) {
  BreadcrumbLink.displayName = "BreadcrumbLink";
}

// src/breadcrumb-item.tsx

var BreadcrumbItem = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbItem2(props, ref) {
  const {
    isCurrentPage,
    separator,
    isLastChild,
    spacing,
    children,
    className,
    ...rest
  } = props;
  const validChildren = (0,_chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_1__/* .getValidChildren */ .WR)(children);
  const clones = validChildren.map((child) => {
    if (child.type === BreadcrumbLink) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        isCurrentPage
      });
    }
    if (child.type === BreadcrumbSeparator) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        spacing,
        children: child.props.children || separator
      });
    }
    return child;
  });
  const styles = useBreadcrumbStyles();
  const itemStyles = {
    display: "inline-flex",
    alignItems: "center",
    ...styles.item
  };
  const _className = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-breadcrumb__list-item", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.li */ .m$.li, {
    ref,
    className: _className,
    ...rest,
    __css: itemStyles
  }, clones, !isLastChild && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbSeparator, {
    spacing
  }, separator));
});
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__/* .__DEV__ */ .Ts) {
  BreadcrumbItem.displayName = "BreadcrumbItem";
}



/***/ }),

/***/ 2651:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dicas",
      function () {
        return __webpack_require__(4343);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2954:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/dica-image-1.e0887dd6.jpg","height":280,"width":422,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAcEAACAgIDAAAAAAAAAAAAAAABAgADBBESISL/xAAVAQEBAAAAAAAAAAAAAAAAAAAEBf/EABgRAAMBAQAAAAAAAAAAAAAAAAABAhEy/9oADAMBAAIRAxEAPwCafNsRVUD0LOSuDoqQOtRESZMrA0co/9k="});

/***/ }),

/***/ 3972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CardLeaf; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(872);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./styles/stitches.config.ts
var stitches_config = __webpack_require__(4767);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/avatar/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(3345);
// EXTERNAL MODULE: ./components/Typography/Text/index.tsx
var Text = __webpack_require__(7818);
;// CONCATENATED MODULE: ./components/CardLeaf/styles.ts



var CardLeaf = (0,stitches_config/* styled */.zo)("div", {
    // maxHeight: 468,
    borderRadius: "0 100px 0 100px",
    border: "solid 1px",
    borderColor: "$emerald500",
    overflow: "hidden",
    cursor: "pointer",
    transition: "all 0.3s",
    "&:hover": {
        background: "$emerald50",
        transition: "all 0.3s"
    }
});
var Figure = (0,stitches_config/* styled */.zo)("figure", {
    position: "relative",
    height: 230,
    "@md": {
        height: 280
    }
});
var Image = (0,stitches_config/* styled */.zo)("img", {
    width: "100%",
    objectFit: "cover",
    height: "100%"
});
var Content = (0,stitches_config/* styled */.zo)("div", {
    padding: "30px 27px",
    h3: {
        fontSize: "20px !important"
    }
});
var Time = (0,stitches_config/* styled */.zo)("time", {
    marginBottom: 16,
    padding: "4px 8px",
    display: "inline-block",
    color: "$white",
    background: "$emerald500",
    fontFamily: "$manrope",
    fontSize: 13,
    borderRadius: 4
});
var AuthorWrap = (0,stitches_config/* styled */.zo)("div", {
    display: "flex",
    alignItems: "center",
    marginTop: 20,
    marginLeft: 15
});
var Avatar = (0,stitches_config/* styled */.zo)(index_esm/* Avatar */.qE, {
    overflow: "hidden"
});
var Author = (0,stitches_config/* styled */.zo)(Text/* default */.Z, {
    color: "$grey600",
    marginLeft: 8
});

;// CONCATENATED MODULE: ./components/CardLeaf/index.tsx




var CardLeaft = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardLeaf, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Figure, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: props.image,
                    layout: "fill",
                    objectFit: "cover",
                    title: props.metaImgTitle,
                    alt: props.metaImgAlt
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    props.time && /*#__PURE__*/ (0,jsx_runtime.jsx)(Time, {
                        children: props.time
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        title: props.metaTitle,
                        children: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthorWrap, {
                        children: [
                            props.author && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                                size: "xs",
                                name: props.author,
                                children: props.photo && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "".concat(props.photo),
                                    layout: "fill",
                                    objectFit: "cover",
                                    alt: props.author
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Author, {
                                children: props.author
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CardLeaf = (CardLeaft);


/***/ }),

/***/ 7309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/breadcrumb/dist/index.esm.js
var index_esm = __webpack_require__(3238);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/Footer/index.tsx + 2 modules
var Footer = __webpack_require__(7386);
// EXTERNAL MODULE: ./components/Navbar/index.js + 4 modules
var Navbar = __webpack_require__(6697);
// EXTERNAL MODULE: ./components/Container/index.tsx
var Container = __webpack_require__(1344);
// EXTERNAL MODULE: ./styles/stitches.config.ts
var stitches_config = __webpack_require__(4767);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(7573);
;// CONCATENATED MODULE: ./components/Layout/Default/styles.ts


var Top = (0,stitches_config/* styled */.zo)("div", {
    position: "relative",
    "& .chakra-breadcrumb": {
        fontFamily: "$raleway",
        fontWeight: 600,
        fontSize: (0,polished_esm/* rem */.hO)(12),
        color: "$grey600",
        "& li": {
            "&:last-of-type": {
                color: "$emerald500"
            }
        }
    }
});
var Background = (0,stitches_config/* styled */.zo)("div", {
    width: "100%",
    paddingTop: 60,
    backgroundImage: "url(/banner_gramas.webp)",
    backgroundSize: "cover",
    position: "relative"
});
var WrapBox = (0,stitches_config/* styled */.zo)("div", {});
var Box = (0,stitches_config/* styled */.zo)("div", {
    position: "relative",
    left: "50%",
    marginTop: 90,
    padding: "16px",
    transform: "translateX(-50%)",
    flexDirection: "column",
    background: "$white",
    borderRadius: "32px 32px 0 0",
    textAlign: "center",
    width: "90%",
    "@xl": {
        padding: "16px 90px",
        width: "auto",
        display: "inline-flex"
    }
});
var Category = (0,stitches_config/* styled */.zo)("h1", {
    fontFamily: "$domine",
    fontWeight: "bold",
    color: "$grey900",
    fontSize: (0,polished_esm/* rem */.hO)(24),
    "@md": {
        fontSize: (0,polished_esm/* rem */.hO)(54)
    }
});
var CategorySmall = (0,stitches_config/* styled */.zo)("h2", {
    fontFamily: "$raleway",
    fontWeight: " !important",
    color: "$grey900",
    margin: "16px 0",
    fontSize: "".concat((0,polished_esm/* rem */.hO)(16), " !important")
});
var ScientifcName = (0,stitches_config/* styled */.zo)("h2", {
    fontFamily: "$raleway",
    fontWeight: "normal !important",
    fontStyle: "italic",
    color: "$grey900",
    margin: "16px 0",
    fontSize: "".concat((0,polished_esm/* rem */.hO)(16), " !important")
});
var Main = (0,stitches_config/* styled */.zo)("main", {
    "& section": {
        paddingTop: 50,
        paddingBottom: 100
    }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var dist_index_esm = __webpack_require__(3382);
;// CONCATENATED MODULE: ./components/Layout/Default/index.tsx













var convertBreadcrumb = function(string) {
    return string.replace(/-/g, " ").replace(/oe/g, "\xf6").replace(/ae/g, "\xe4").replace(/ue/g, "\xfc").charAt(0).toUpperCase() + string.slice(1);
};
function Layout(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), breadcrumbs = ref[0], setBreadcrumbs = ref[1];
    (0,react.useEffect)(function() {
        if (router) {
            var linkPath = router.asPath.split("/");
            linkPath.shift();
            var pathArray = linkPath.map(function(path, i) {
                return {
                    breadcrumb: path.split("?")[0],
                    href: "/" + linkPath.slice(0, i + 1).join("/")
                };
            });
            setBreadcrumbs(pathArray);
        }
    }, [
        router
    ]);
    // if (!breadcrumbs) {
    //   return null
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: props.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: props.keywords
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    props.links && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://centraldagrama.com".concat(props.links)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: props.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "".concat(props.cover ? props.cover : "https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:card",
                        content: "summary_large_image"
                    }),
                    props.links && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://centraldagrama.com/".concat(props.links)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:title",
                        content: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:description",
                        content: props.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:image",
                        content: "".concat(props.cover ? props.cover : "https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Top, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Background, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapBox, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Category, {
                                        css: props.categorySize ? (0,_object_spread/* default */.Z)({}, {
                                            fontSize: "".concat(props.categorySize, " !important")
                                        }) : {},
                                        children: props.category
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Breadcrumb */.aG, {
                                        separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ChevronRightIcon */.XC, {
                                            color: "gray.600"
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BreadcrumbItem */.gN, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BreadcrumbLink */.At, {
                                                        children: "In\xedcio"
                                                    })
                                                })
                                            }),
                                            breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map(function(breadcrumb, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BreadcrumbItem */.gN, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: breadcrumb.href,
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BreadcrumbLink */.At, {
                                                            children: convertBreadcrumb(breadcrumb.breadcrumb)
                                                        })
                                                    })
                                                }, i);
                                            })
                                        ]
                                    }),
                                    props.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScientifcName, {
                                        children: props.subtitle
                                    }),
                                    props.h2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySmall, {
                                        children: props.h2
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Main, {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};


/***/ }),

/***/ 7818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4767);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7573);


var Text = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("p", {
    fontFamily: "$raleway",
    fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hO)(13),
    lineHeight: "180%",
    variants: {
        align: {
            center: {
                textAlign: "center"
            }
        },
        type: {
            semiBold: {
                fontWeight: 600
            },
            bold: {
                fontWeight: "bold"
            },
            lead: {
                fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hO)(11),
                fontWeight: 600,
                "@xxl": {
                    fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hO)(18)
                }
            }
        },
        size: {
            sm: {
                fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hO)(12)
            }
        }
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (Text);


/***/ }),

/***/ 4343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8641);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3621);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9081);
/* harmony import */ var components_Layout_Default__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7309);
/* harmony import */ var components_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1344);
/* harmony import */ var components_CardLeaf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3972);
/* harmony import */ var public_images_dica_image_1_jpg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2954);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5313);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);











var Dicas = function(param) {
    var data = param.data;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Layout_Default__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        category: "Dicas",
        title: "Dicas de grama, cuidados e manuten\xe7\xe3o",
        description: "Nessa sess\xe3o do site, voc\xea vai aprender as principais dicas de como plantar, cuidar e manter o seu gramado bonito e saud\xe1vel, al\xe9m de dicas para remo\xe7\xe3o de pragas...",
        keywords: "dicas de grama, dicas de como plantar grama, dicas de plantio de grama, dicas como para plantar grama esmeralda, dicas de manuten\xe7\xe3o de grama, dicas de manuten\xe7\xe3o de gramdo, dicas de grama para jardim, dicas de como combater ervas daninhas, dicas de como remover pragas na grama",
        links: router.asPath,
        categorySize: "1.6rem",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .SimpleGrid */ .MI, {
                    columns: [
                        1,
                        1,
                        2,
                        null,
                        3
                    ],
                    spacing: 15,
                    children: data === null || data === void 0 ? void 0 : data.map(function(item) {
                        var ref, ref1, ref2;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                            href: "/dicas/".concat(item.slug),
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CardLeaf__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    image: (0,utils__WEBPACK_IMPORTED_MODULE_8__/* .transformHttpToHttps */ .T)(item.x_featured_media_original) || public_images_dica_image_1_jpg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                                    title: item.title.rendered,
                                    time: (0,date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(new Date(item.date), "EEEE, d MMMM, Y ", {
                                        locale: date_fns_locale__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z
                                    }),
                                    author: item.x_author,
                                    photo: item === null || item === void 0 ? void 0 : item.author.author_avatar,
                                    metaImgTitle: item === null || item === void 0 ? void 0 : (ref = item.acf) === null || ref === void 0 ? void 0 : ref.title_img_othertips,
                                    metaImgAlt: item === null || item === void 0 ? void 0 : (ref1 = item.acf) === null || ref1 === void 0 ? void 0 : ref1.alt_img_othertips,
                                    metaTitle: item === null || item === void 0 ? void 0 : (ref2 = item.acf) === null || ref2 === void 0 ? void 0 : ref2.title_text_othertips
                                })
                            })
                        }, "tip-".concat(item.id));
                    })
                })
            })
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Dicas);


/***/ }),

/***/ 5313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ countComments; },
/* harmony export */   "T": function() { return /* binding */ transformHttpToHttps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9815);



var countComments = function(comments) {
    var flatComments = comments.flatMap(function(comment) {
        if (comment.replies) {
            return [
                (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, comment), {
                    replies: false
                })
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(comment.replies.map(function(reply) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, reply), {
                    status: false
                });
            })));
        }
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, comment), {
            replies: false
        });
    });
    var commentsActive = flatComments.filter(function(item) {
        return item.status;
    });
    return (commentsActive === null || commentsActive === void 0 ? void 0 : commentsActive.length) || 0;
};
var transformHttpToHttps = function(url) {
    if (!url) return "";
    return url.replace("http://", "https://");
};


/***/ }),

/***/ 943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 3375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 9815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 1566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [753,345,538,112,774,888,179], function() { return __webpack_exec__(2651); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);